import axios from 'axios';
import API_BASE_URL from '../config';

// Configurazione axios con interceptor per token
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor per aggiungere token JWT se disponibile
api.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    const userToken = localStorage.getItem('token');
    const token = adminToken || userToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ============ EVENTI ============

/**
 * Recupera tutti gli eventi del Becco
 * @param {number} adminId - ID dell'admin
 * @param {object} filters - {status?, upcoming?, past?}
 */
export const getEvents = async (adminId, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.upcoming) params.append('upcoming', 'true');
  if (filters.past) params.append('past', 'true');
  
  const response = await api.get(`/events/${adminId}?${params.toString()}`);
  // Restituisce { success: true, data: [...] }
  return response.data;
};

/**
 * Alias per compatibilità
 */
export const getAllEvents = getEvents;

/**
 * Recupera dettaglio di un singolo evento
 * @param {number} eventId - ID dell'evento
 */
export const getEventById = async (eventId) => {
  const response = await api.get(`/events/detail/${eventId}`);
  return response.data;
};

/**
 * Crea un nuovo evento
 * @param {object} eventData - {adminId, title, description?, location?, eventDate, startTime?, endTime?, eventType, color?, maxParticipants?, isPublic?, notifyBefore?, invitedUserIds?}
 */
export const createEvent = async (eventData) => {
  const response = await api.post('/events', eventData);
  return response.data;
};

/**
 * Aggiorna un evento esistente
 * @param {number} eventId - ID dell'evento
 * @param {object} updates - Campi da aggiornare
 */
export const updateEvent = async (eventId, updates) => {
  const response = await api.put(`/events/${eventId}`, updates);
  return response.data;
};

/**
 * Elimina un evento
 * @param {number} eventId - ID dell'evento
 * @param {number} adminId - ID dell'admin (per verifica)
 */
export const deleteEvent = async (eventId, adminId) => {
  const response = await api.delete(`/events/${eventId}`, {
    data: { adminId }
  });
  return response.data;
};

/**
 * Invita partecipanti a un evento
 * @param {number} eventId - ID dell'evento
 * @param {number} adminId - ID dell'admin
 * @param {array} userIds - Array di ID utenti da invitare
 */
export const inviteParticipants = async (eventId, adminId, userIds) => {
  const response = await api.post(`/events/${eventId}/participants`, {
    adminId,
    userIds
  });
  return response.data;
};

/**
 * User risponde a un invito
 * @param {number} eventId - ID dell'evento
 * @param {number} userId - ID dell'utente
 * @param {string} status - 'accepted' | 'declined' | 'maybe'
 * @param {string} notes - Note opzionali
 */
export const respondToInvite = async (eventId, userId, status, notes = null) => {
  const response = await api.put(`/events/${eventId}/participate`, {
    userId,
    status,
    notes
  });
  return response.data;
};

export default {
  getEvents,
  getAllEvents,
  getEventById,
  createEvent,
  updateEvent,
  deleteEvent,
  inviteParticipants,
  respondToInvite
};
